import React, { useMemo } from 'react';
import { LookupSelect, type LookupSelectProps } from './LookupSelect';
import { useCrewLookupSlice } from './useLookupOptions';
import { labelWithAbrv, type LookupRecord } from './lookupHelpers';

function keepIdsKey(includeIds: LookupSelectProps['includeIds']): string {
  return (includeIds ?? [])
    .map((id: string | number | null | undefined) => (id == null || id === '' ? '' : String(id)))
    .filter(Boolean)
    .join(',');
}

export function createCrewLookupSelect(
  displayName: string,
  slice: string,
  getLabel: (item: LookupRecord) => string = labelWithAbrv,
) {
  function Comp({ includeIds, ...props }: LookupSelectProps) {
    const keepKey = keepIdsKey(includeIds);
    const keepIds = useMemo(
      () => (keepKey ? keepKey.split(',') : undefined),
      [keepKey],
    );
    const { options, isLoading } = useCrewLookupSlice(slice, keepIds, getLabel);
    return <LookupSelect {...props} includeIds={includeIds} options={options} isLoading={isLoading} />;
  }
  Comp.displayName = displayName;
  return Comp;
}
